<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="title_head">
              Roles List <span v-if="r_rights === true"><button type="button" variant="secondary" class="btn btn-sm btn-primary label_bttn" @click="addRoles()"><i class="fa fa-plus"></i> Create Custom Role</button><p v-show="hide">{{ r_view }}</p></span>
            </div>
          </div>
          <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div v-if="message!=''" class="alert alert-success" >
                    <center>{{message}}</center>
                  </div>
                </div>
              </div>
            <div>
              <vue-good-table :columns="columns1" :rows="rows1" mode="remote" ref="my-table" :totalRows="totalRecords" @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :pagination-options ="{enabled: true, perPage: 5}" styleClass="vgt-table striped bordered table-sm condensed">
                <template slot="table-row" slot-scope="props" >
                  <span v-if="props.column.field == 'action'">
                    <i class="fa fa-eye" @click="viewpermission(props.row)"></i>
                    <span v-if='props.row.company_id !== "I2OCGLB"'>
                      <i class="fa fa-edit" @click="editpermission(props.row)"></i>
                      <i class="fa fa-trash" @click="deletepermission(props.row)"></i>
                    </span>
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- ADD ROLES -->
    <b-modal title="Add Role Type" hide-footer size="lg" v-model="roletype" @ok="largeModal = false" class="modal-primary">
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <label for="name">Role Type Name:</label>
            <b-form-input ref="txtrolename" type="text" v-model="role_name"  autocomplete="off" placeholder="Enter New Role Type" :class="{'is-invalid':haserror.role_name}"  @blur.native="chkExist()"></b-form-input>
            <small v-if="haserror.role_name" class="form-text text-muted"><strong style="color: red;">{{haserror.role_name}}</strong></small>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6"></b-col>
        <b-col sm="3">
          <b-form-group>
            <input type="checkbox" @change="selectallview('add')" v-model="selectallview_add"><strong>Select All</strong>
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-group>
           <input type="checkbox" @change="selectallrights('add')" v-model="selectallrights_add"><strong>Select All</strong>
          </b-form-group>
        </b-col>
      </b-row>
      <vue-good-table :columns="columns" :rows="rows" styleClass="vgt-table striped bordered table-sm condensed">
        <template slot="table-row" slot-scope="props" >
          <span v-if="props.column.field == 'action'">
            <i class="fa fa-edit" @click.prevent="editpro(props.row)"></i>
            <i class="fa fa-trash" @click.prevent="deletebrand(props.row)"></i>
          </span>
          <!-- view -->
          <span v-else-if="props.column.field == 'view'">
            <input type="checkbox" @change="checkedview(props.row.originalIndex)" v-model="checkview[props.row.originalIndex]">
          </span>
          <!-- Rights -->
          <span v-else-if="props.column.field == 'rights'">
            <input type="checkbox" @change="checkedrights(props.row.originalIndex)" v-model="checkrights[props.row.originalIndex]">
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" @click="close_addroles()" data-dismiss="modal">Close</button>
        <button type="button" @click="create_roles()" class="btn btn-primary"><i class="fa fa-dot-circle-o"></i> Save</button>
      </div>
    </b-modal> 



    <!-- VIEW ROLES -->
    <b-modal title="View Role Type" hide-footer size="lg" v-model="viewroles" @ok="largeModal = false" class="modal-primary">
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <label for="name">Role Type: <strong>{{role_name_view}}</strong></label>
          </b-form-group>
        </b-col>
      </b-row>
      <vue-good-table :columns="columns" :rows="rows" styleClass="vgt-table striped bordered table-sm condensed">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'">
            <i class="fa fa-edit" @click.prevent="editpro(props.row)"></i>
            <i class="fa fa-trash" @click.prevent="deletebrand(props.row)"></i>
          </span>
          <!-- view -->
          <span v-else-if="props.column.field == 'view'">
            <input type="checkbox" disabled="disabled" v-model="checkview_view[props.row.originalIndex]">
          </span>
          <!-- add -->
          <span v-else-if="props.column.field == 'rights'" >
            <input type="checkbox" disabled="disabled" v-model="checkrights_view[props.row.originalIndex]">
          </span>
      
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </b-modal>


    <!-- EDIT ROLES -->
    <b-modal title="Edit Role Type" hide-footer size="lg" v-model="editmodal" @ok="largeModal = false" class="modal-primary">
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <label for="name">Role Type :</label>
            <b-form-input type="text" v-model="role_name1"  autocomplete="off" placeholder="Enter New Role Type"></b-form-input>
            <small v-if="haserror.role_name1!=''" class="form-text text-muted"><strong style="color: red;">{{haserror.role_name1}}</strong></small>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6"></b-col>
        <b-col sm="3">
          <b-form-group>
            <input type="checkbox" @change="selectallview('edit')" v-model="selectallview_edit"><strong>Select All</strong>
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-group>
           <input type="checkbox" @change="selectallrights('edit')" v-model="selectallrights_edit"><strong>Select All</strong>
          </b-form-group>
        </b-col>
      </b-row>
      <vue-good-table :columns="columns" :rows="rows" styleClass="vgt-table striped bordered table-sm condensed">
        <template slot="table-row" slot-scope="props" >
          <span v-if="props.column.field == 'action'">
            <i class="fa fa-edit" @click.prevent="editpro(props.row)"></i>
            <i class="fa fa-trash" @click.prevent="deletebrand(props.row)"></i>
          </span>
          <!-- view -->
          <span v-else-if="props.column.field == 'view'">
            <input type="checkbox" @change="checkedview_edit(props.row.originalIndex)" v-model="checkview_edit[props.row.originalIndex]">
          </span>
          <!-- add -->
          <span v-else-if="props.column.field == 'rights'">
            <input type="checkbox" @change="checkedrights_edit(props.row.originalIndex)" v-model="checkrights_edit[props.row.originalIndex]">
          </span>
         
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
      <div class="modal-footer">
      <button type="button" @click="update_roles()" class="btn btn-primary"><i class="fa fa-dot-circle-o"></i> Save</button>
      </div>
    </b-modal>
    <Spinner v-show="loading"></Spinner> 
  </div>
</template>

<script>
import Spinner from '../../spinner.vue'
export default {
  name:'vuedt',
  components: {
    Spinner
  },
  data(){
    return{
      hide:false,
      roletype: false,
      viewroles: false,
      editmodal: false,
      loading:false,
      role_name_view: '',
      checkview: [],
      checkrights: [],
      checkview_view: [],
      checkrights_view: [],
      checkview_edit: [],
      checkrights_edit: [],
      selectallview_edit: false,
      selectallrights_edit: false,
      selectallview_add: false,
      selectallrights_add: false,
      message:'',
      role_name: '',
      role_name1: '',
      haserror:{
        role_name:false,
        role_name1:'',
      },
      columns: [
        {
          label: 'Page Name',
          field: 'pagename',
          width: '25% !important',
        },
        {
          label: 'View Only',
          field: 'view',
          width: '15% !important',
        },
        {
          label: 'Add/Update',
          field: 'rights',
          width: '15% !important',
        },
        
      ],
      rows: [],
       totalRecords: 0,
        serverParams: {
        columnFilters: {},
        sort: {},
        page: 1, 
        perPage: 5
      },
      new_roles: [],
      columns1: [
        {
          label: 'Role Type',
          field: 'role_name',
          width: '55% !important',
        },
        {
          label: 'Created At',
          field: 'lastupdated_datetime',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'DD MMMM YYYY',
          tdClass: 'text-left',
          thClass: 'text-left',
          width: '35% !important'
        },
        {
          label: 'Action',
          field: 'action',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '10% !important',
        },
      ],
      rows1: [],
    }
  },
  computed: {
    r_view: function(){
      if(this.$store.getters.get_r_view === true){
        this.getRoles();
        this.getPageNames();
        this.shopuser();
        return true
      }
      else{
        return false
      }
    },

    r_rights: function(){
      return this.$store.getters.get_r_rights
    },
  },

  methods: {

    chkExist(){
      var _this = this
      this.role_name = this.role_name.trim()
      if(this.role_name != ''){
        this.$http.get('/api/roletbs/chk_exist?filter[where][role_name]='+this.role_name).then(function (response){
          if(response.data.length > 0){
            _this.role_name = ''
            _this.haserror.role_name = 'Role name already exist'
            _this.$refs['txtrolename'].focus()
          }
          else{
            _this.haserror.role_name = false
          }
        })
        .catch(function(error){
          _this.haserror.role_name = false
        });
      }
      else{
         _this.haserror.role_name = false
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) { 
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    loadItems(){
      var _this=this
      this.loading = true
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.$http.get('/api/roletbs?params='+ JSON.stringify(filteParam)).then(function(response){
        if(response.data != undefined){
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift()
          _this.rows1 = response.data
          _this.loading = false
        }
      }).catch(function(error){
      })
    },

    shopuser(){
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){

      }).catch(function(error){
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },

    viewpermission(row){
      var data = {}
      this.checkview_view = []
      this.checkrights_view = []
      this.rows = []
      this.role_name_view = ''
      data.role_id = row.role_id
      var _this=this
      this.$http.post('/api/permissiontbs/permission',data).then(function(response){
        _this.viewroles = true
        _this.rows = response.data.data
        _this.role_name_view = response.data.data[0]['role_name']
        if(response.data.data.length > 0){
          for(var i=0;i<response.data.data.length;i++){
            _this.checkview_view[i] = response.data.data[i]['view']
            _this.checkrights_view[i] = response.data.data[i]['rights']
          }
        }
      }).catch(function(error){
      
      })
    },

    editpermission(row){
      var data = {}
      this.checkview_edit = []
      this.checkrights_edit = []
      this.rows = []
      this.role_name1 = ''
      data.role_id = row.role_id
      var _this=this
      this.$http.post('/api/permissiontbs/permission',data).then(function(response){
        _this.editmodal = true
        _this.rows = response.data.data
        _this.role_name1 = response.data.data[0]['role_name']
        if(response.data.data.length > 0){
          for(var i=0;i<response.data.data.length;i++){
            _this.checkview_edit[i] = response.data.data[i]['view']
            _this.checkrights_edit[i] = response.data.data[i]['rights']
          }
        }
      }).catch(function(error){
      
      })
    },

    deletepermission(row){
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this
        this.loading=true
        this.$http.delete('/api/roletbs/'+row.role_id) .then(function (response) {
          _this.loading=false
          _this.getRoles()
        }).catch(function (error) {
          if(error.response.status === 444){
            _this.loading=false
            _this.message = 'Cannot delete role "'+row.role_name+'" it has been assigned to user'
            setTimeout(function(){_this.message=false;}, 6000);
          }else{
            console.log('error.response')
          }
        });
      }
    },

    addRoles(){
      this.roletype = true
      this.haserror.role_name = ''
      this.role_name = ''
      this.checkview = []
      this.checkrights = []
      this.rows = []
      this.rows = this.new_roles
      this.selectallview_add=false
      this.selectallrights_add=false
      if(this.rows.length > 0){
        for(var i=0;i<this.rows.length;i++){
          this.rows[i]['view'] = false
          this.rows[i]['rights'] = false
        }
      }
    },

    getRoles(){
      this.loadItems()
    },

    getPageNames(){
      var _this=this
      this.$http.get('/api/permissionpgs').then(function(response){
        if(response.data.length > 0){
          for(var i=0;i<response.data.length;i++){
            response.data[i]['view'] = false
            response.data[i]['rights'] = false
          }
        }
        _this.new_roles = response.data
        _this.rows = _this.new_roles
      }).catch(function(error){
      
      })
    },

    // NEW ROLES VIEW RIGHTS
    checkedview(index){
      // this.rows[index]['view'] = this.checkview[index]
      
      if (this.checkview[index] === true) {
        this.rows[index]['view'] = true
      }
      else{
        if(this.rows[index]['rights'] === false){
          this.rows[index]['view'] = false
          this.checkview[index] = false
        }
        else{
          this.rows[index]['view'] = true
          this.checkview[index] = true
        } 
      }
    },

    checkedrights(index){
      this.rows[index]['rights'] = this.checkrights[index]
      if(this.checkrights[index] === true){
        this.checkview[index] = true
        this.rows[index]['view'] = true
      }
    },

    // EDIT ROLES VIEW RIGHTS
    checkedview_edit(index){
      // this.rows[index]['view'] = this.checkview_edit[index]
      if (this.checkview_edit[index] === true) {
        this.rows[index]['view'] = true
      }
      else{
        if(this.rows[index]['rights'] === false){
          this.rows[index]['view'] = false
          this.checkview_edit[index] = false
        }
        else{
          this.rows[index]['view'] = true
          this.checkview_edit[index] = true
        } 
      }
    },

    checkedrights_edit(index){
      this.rows[index]['rights'] = this.checkrights_edit[index]
      if ( this.checkrights_edit[index] === true) {
        this.checkview_edit[index] = true
        this.rows[index]['view'] = true
      }
    },
    close_addroles(){
      this.roletype = false
    },
    create_roles(){
      var _this = this
      var data = {}
      var submit = 0
      data.role_name = this.role_name
      data.permission = this.rows
      _this.haserror.role_name = ''
      if(data.role_name == ''){
        submit = 1
        _this.haserror.role_name = "Required"
      }else if(data.role_name.length < 2){
        submit = 1
        _this.haserror.role_name = "Minimum 2 characters required"
      }else if(data.role_name.length > 30){
        submit = 1
        _this.haserror.role_name = "Cannot be greater than 30 characters"
      }
      if(submit == 0){
        this.loading=true
        this.$http.post('/api/roletbs', data).then(function (response) {
          _this.loading=false
          _this.role_name = ''
          _this.roletype = false
          _this.getRoles()
        })
        .catch(function (error) {

        });
      }
    },

    update_roles(){
      var _this = this
      var data = {}
      var submit = 0
      data.permission = this.rows
      data.role_name = this.role_name1
      _this.haserror.role_name1 = ''
      
      if(data.role_name1 == ''){
        submit = 1
        _this.haserror.role_name1 = "Required"
      }else if(data.role_name.length < 2){
        submit = 1
        _this.haserror.role_name1 = "Minimum 2 characters required"
      }else if(data.role_name.length > 30){
        submit = 1
        _this.haserror.role_name1 = "Cannot be greater than 30 characters"
      }
      
      if(submit == 0){
        this.loading=true
        this.$http.post('/api/roletbs/update_roles', data).then(function (response) {
          _this.loading=false
          _this.role_name1 = ''
          _this.editmodal = false
          _this.getRoles()
        })
        .catch(function (error) {

        });
      }
    },

    selectallview(act){
      if(act === 'add'){
        if (this.selectallview_add === true) {
          for(var i=0;i<this.rows.length;i++){
            this.rows[i]['view'] = true
            this.checkview[i] = true
          }
        }
        else{
          for(var i=0;i<this.rows.length;i++){
            if (this.rows[i]['rights'] === true) {
              this.rows[i]['view'] = true
              this.checkview[i] = true
            }
            else{
              this.rows[i]['view'] = false
              this.checkview[i] = false
            }
          }
        }
      }
      else{
        if (this.selectallview_edit === true) {
          for(var i=0;i<this.rows.length;i++){
            this.rows[i]['view'] = true
            this.checkview_edit[i] = true
          }
        }
        else{
          for(var i=0;i<this.rows.length;i++){
            if (this.rows[i]['rights'] === true) {
              this.rows[i]['view'] = true
              this.checkview_edit[i] = true
            }
            else{
              this.rows[i]['view'] = false
              this.checkview_edit[i] = false
            }
          }
        }
      }
    },

    selectallrights(act){
        if(act === 'add'){
          // console.log(this.selectallrights_add)
          if (this.selectallrights_add === true) {
            this.selectallview_add = true
            for(var i=0;i<this.rows.length;i++){
              this.checkrights[i] = true
              this.rows[i]['rights'] = this.selectallrights_add
            
              this.checkview[i] = true
              this.rows[i]['view'] = true
            }           
          }
          else{
            for(var i=0;i<this.rows.length;i++){
              this.checkrights[i] = false
              this.rows[i]['rights'] = false
            }  
          }
        }
        else{
          if (this.selectallrights_edit === true) {
            this.selectallview_edit = true
            for(var i=0;i<this.rows.length;i++){
              this.checkrights_edit[i] = true
              this.rows[i]['rights'] = this.selectallrights_edit
            
              this.checkview_edit[i] = true
              this.rows[i]['view'] = true
            }           
          }
          else{
            for(var i=0;i<this.rows.length;i++){
              this.checkrights_edit[i] = false
              this.rows[i]['rights'] = false
            }
          }
        }
      },

  },
}
</script>


// WEBPACK FOOTER //
// src/views/setting/Role.vue